import NetworkCardLink from './NetworkCardLink';

export default NetworkCardLink;
